import { getDateTimeString } from "../../css/Utility";

export function TicketMessage({ message }) {
  const isStaff = message.type === 'staff';
  return (
    <div className={`tv-message${isStaff ? ' tv-message--staff' : ''}`}>
      <div className="tv-message-header">
        <img
          className="tv-avatar"
          src={`/images/avatar/${message.avatar}.webp`}
          alt={message.name}
        />
        <div className="tv-sender">
          <p className="tv-sender-name">{message.name}</p>
          {message.title && <p className="tv-sender-title">{message.title}</p>}
        </div>
        <span className="tv-message-time">{getDateTimeString(message.timestamp)}</span>
      </div>
      <div className="tv-message-body">
        <p className="tv-message-content">{message.content}</p>
      </div>
    </div>
  );
}
